export default {
  data () {
    return {
      windowWidth: 0,
      currentWidth: window.innerWidth
    }
  },
  watch: {
    windowWidth (newValue) {
      this.currentWidth = newValue
    }
  },
  created () {
    this.$nextTick(() => {
      window.addEventListener('resize', () => {
        this.windowWidth = window.innerWidth
        this.windowHeight = window.innerHeight
      })
    })
    this.init()
  },
  beforeDestroy () {
    window.removeEventListener('resize', () => {
      this.windowWidth = window.innerWidth
      this.windowHeight = window.innerHeight
    })
  },
  methods: {
    init () {
      this.windowWidth = this.currentWidth
    }
  }
}



// WEBPACK FOOTER //
// ./scripts/src/mixins/windowSize.js